import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Sentry } from '@/vendors/Sentry';

export const audioUrlsFolderName = 'voizor-sales-ui-audio-urls';

export const writeSecretFile = async ({ fileName, folder, data }) => {
  const path = `${folder}/${fileName}`;
  await Filesystem.writeFile({
    path,
    data,
    directory: Directory.Documents,
    encoding: Encoding.UTF8,
    recursive: true,
  });
};

export const readSecretFile = async ({ fileName, folder }) => {
  const contents = await Filesystem.readFile({
    path: `${folder}/${fileName}`,
    directory: Directory.Documents,
    encoding: Encoding.UTF8,
  });
  return contents.data;
};

export const deleteSecretFile = async ({ fileName, folder }) => {
  await Filesystem.deleteFile({
    path: `${folder}/${fileName}`,
    directory: Directory.Documents,
  });
};

export const readAllSecretFiles = async ({ folder }) => {
  try {
    const contents = await Filesystem.readdir({
      path: `${folder}`,
      directory: Directory.Documents,
    });

    return contents.files.map(({ name }) => name);
  } catch (error) {
    if (
      error.message.includes('does not exist') ||
      error.message.includes('because there is no such file')
    ) {
      return [];
    } else {
      Sentry.captureException(error);
      throw error;
    }
  }
};

export const checkFileExists = async ({ folder, fileName }) => {
  try {
    await Filesystem.stat({
      path: `${folder}/${fileName}`,
      directory: Directory.Documents,
    });
    return true;
  } catch (checkDirException) {
    if (
      checkDirException.message === 'Entry does not exist.' ||
      checkDirException.message.includes('because there is no such file')
    ) {
      return false;
    } else {
      Sentry.captureException(checkDirException);
      throw checkDirException;
    }
  }
};

// const readFilePath = async () => {
//   // Here's an example of reading a file with a full file path. Use this to
//   // read binary data (base64 encoded) from plugins that return File URIs, such as
//   // the Camera.
//   const contents = await Filesystem.readFile({
//     path: 'file:///var/mobile/Containers/Data/Application/22A433FD-D82D-4989-8BE6-9FC49DEA20BB/Documents/text.txt',
//   });

//   console.log('data:', contents);
// };
